export const URI_HELP_TEXT = 'Enter the complete URL where customers can perform this action.';

export const IS_PREFERRED_HELP_TEXT =
  'Mark this action as the primary/preferred option. Only one action can be set as preferred. If you enable this, any other preferred action will automatically be disabled. Preferred actions appear first in Google Business Profile listings.';

export const URI_PLACEHOLDER = 'https://example.com/your-action-link';

export const CLEAR_MODAL_HEADER = 'Clear Place Action';

export const CLEAR_MODAL_CONTENT =
  'Are you sure you want to clear this action? It will be removed from your Google Business Profile listing.';
